<div class="updox-compose-window" [class.minimized]="draft.minimized">
  <!-- Title bar -->
  <div class="updox-compose-header" (click)="toggleMinimize()">
  <span class="fw-500 updox-text-ellipsis" *ngIf="!draft.replyTo">
    {{ draft.subject || 'New Message' }}
  </span>

    <div class="updox-compose-reply-bar" *ngIf="draft.replyTo">
      <i class="fa fa-reply mr-sm text-secondary"></i>
      <span class="fw-500">
      <strong>{{ draft.replyTo.from_address }}</strong>
    </span>
    </div>

    <div class="updox-compose-header-actions" (click)="$event.stopPropagation()">
      <a class="ml-sm" *ngIf="allowMinimize" (click)="toggleMinimize()" title="{{ draft.minimized ? 'Restore' : 'Minimize' }}">
        <i class="fa" [class.fa-minus]="!draft.minimized" [class.fa-chevron-up]="draft.minimized"></i>
      </a>
      <a class="ml-sm text-danger" (click)="close.emit()" title="Close">
        <i class="fa fa-times"></i>
      </a>
    </div>
  </div>

  <!-- Compose body (hidden when minimized) -->
  <div class="updox-compose-body" *ngIf="!draft.minimized">

    <!-- Patient field — always visible; search input until a patient is chosen, then badge -->
    <div class="updox-compose-patient-row">

      <!-- State A: resolving pre-set patient_id (reply / draft edit / billing send) -->
      <ng-container *ngIf="patientLoading">
        <i class="fa fa-spinner fa-spin mr-sm text-muted fs13"></i>
        <span class="text-muted fs12">Loading patient…</span>
      </ng-container>

      <!-- State B: patient confirmed — show badge with × to unlink -->
      <ng-container *ngIf="chartPatient && !patientLoading">
        <i class="fa fa-user-circle-o mr-sm text-secondary fs14" style="flex-shrink:0"></i>
        <div class="updox-compose-patient-info">
          <span class="fw-500 fs13">{{chartPatient.name}}</span>
          <span class="text-muted fs12 ml-sm" *ngIf="patientDemographics(chartPatient) as demo">· {{demo}}</span>
        </div>
        <a class="updox-compose-patient-unlink text-muted" *ngIf="!draft.patientLocked"
           (click)="unlinkPatient()" title="Remove patient link">
          <i class="fa fa-times fs11"></i>
        </a>
      </ng-container>

      <!-- State C: no patient yet — inline live-search field -->
      <ng-container *ngIf="!chartPatient && !patientLoading">
        <i class="fa fa-user-o mr-sm text-muted fs13" style="flex-shrink:0"></i>
        <div class="updox-compose-patient-search-wrap">
          <input type="text" class="updox-compose-patient-input"
                 placeholder="Search patient (optional)…"
                 [value]="chartPatientQuery"
                 (input)="onChartPatientQueryChange($any($event.target).value)"
                 (blur)="closeChartPatientDropdownDelayed()"
                 autocomplete="off" />
          <i class="fa fa-spinner fa-spin updox-compose-patient-spinner text-muted"
             *ngIf="chartPatientSearchLoading"></i>
          <!-- Results dropdown suppressed when chart panel is open (panel has its own dropdown) -->
          <div class="updox-patient-dropdown"
               *ngIf="showChartPatientDropdown && chartPatientResults.length > 0 && !showChartPanel">
            <div class="updox-patient-option"
                 *ngFor="let p of chartPatientResults"
                 (mousedown)="selectChartPatient(p)">
              <span class="updox-avatar updox-avatar-xs">{{patientInitialFor(p)}}</span>
              <div class="updox-patient-option-info">
                <div class="fw-500 fs13">{{p.name}}</div>
                <div class="updox-patient-option-meta" *ngIf="patientDemographics(p) as demo">
                  <i class="fa fa-id-card-o mr-sm text-muted"></i>{{demo}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

    </div>

    <!-- To field with typeahead -->
    <div class="updox-compose-field" *ngIf="!draft.replyTo" >
      <div class="updox-to-wrap">
        <input type="text" class="form-control updox-compose-input"
               placeholder="Recipient"
               [(ngModel)]="draft.to_address"
               (ngModelChange)="onToInput($event)"
               (blur)="closeDropdownDelayed()"
               autocomplete="off" />
        <i class="fa fa-spinner fa-spin text-primary updox-to-spinner" *ngIf="toSearchLoading"></i>

        <div class="updox-to-dropdown scroll-browser" *ngIf="showToDropdown">

          <ng-container *ngIf="localResults.length > 0">
            <div class="updox-to-section-header">Your Contacts</div>
            <div class="updox-to-option" *ngFor="let r of localResults"
                 (mousedown)="selectToContact(r)">
              <span class="updox-avatar updox-avatar-xs">{{ r.name?.charAt(0)?.toUpperCase() || '?' }}</span>
              <div class="updox-to-option-info">
                <div class="fw-500 fs13">{{ r.name }}</div>
                <div class="text-muted fs12 updox-text-ellipsis">{{ r.direct_address }}</div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="directoryResults.length > 0">
            <div class="updox-to-section-header">
              <i class="fa fa-search mr-sm"></i>Directory
            </div>
            <div class="updox-to-option" *ngFor="let r of directoryResults"
                 (mousedown)="selectToContact(r)">
              <span class="updox-avatar updox-avatar-xs updox-avatar-dir">{{ r.name?.charAt(0)?.toUpperCase() || '?' }}</span>
              <div class="updox-to-option-info">
                <div class="fw-500 fs13">{{ r.name }}</div>
                <div class="text-muted fs12 updox-text-ellipsis">{{ r.direct_address }}</div>
                <div class="text-muted fs12" *ngIf="r.organization">{{ r.organization }}<span *ngIf="r.specialty"> · {{ r.specialty }}</span></div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>
    </div>

    <!-- Subject field -->
    <div class="updox-compose-field">
      <!--      <label class="updox-compose-label fw-500 text-gray-dark">Subject</label>-->
      <input type="text" class="form-control updox-compose-input"
             placeholder="Subject"
             [(ngModel)]="draft.subject" />
    </div>

    <!-- Message body -->
    <textarea class="form-control updox-compose-textarea"
              placeholder="Write your secure message here..."
              [(ngModel)]="draft.body_text"></textarea>

    <!-- Hidden file input -->
    <input type="file" multiple #fileInput style="display:none"
           accept=".pdf,.xml,.jpg,.jpeg,.png,.doc,.docx"
           (change)="onFilesSelected($event)" />

    <!-- Attachment bar -->
    <div class="updox-compose-attachments-bar">


      <!-- Chips: local files -->
      <div class="updox-compose-file-chips" *ngIf="attachedFiles.length > 0 || chartAttachedDocs.length > 0">
        <span class="updox-compose-file-chip" *ngFor="let f of attachedFiles; let i = index">
          <i class="fa {{ fileIcon(f) }} mr-sm"></i>
          <span class="updox-compose-chip-name mr-sm">{{ f.name }}</span>
          <span class="text-muted fs10 mr-sm">({{ formatFileSize(f.size) }})</span>
          <a class="text-primary updox-compose-chip-remove" (click)="removeAttachment(i)" title="Remove">
            <i class="fa fa-times-circle"></i>
          </a>
        </span>
        <!-- Chips: from patient chart -->
        <span class="updox-compose-file-chip updox-compose-chip-chart" *ngFor="let d of chartAttachedDocs">
          <i class="fa fa-folder-open-o mr-sm text-secondary"></i>
          <span class="updox-compose-chip-name">{{ d.name || d.file_name }}</span>
          <span class="text-muted fs10 ml-sm" *ngIf="d.document_type_name">({{ d.document_type_name }})</span>
          <a class="ml-sm text-secondary updox-compose-chip-remove" (click)="removeChartDoc(d.id)" title="Remove">
            <i class="fa fa-times-circle"></i>
          </a>
        </span>
        <span class="text-muted fs11 ml-sm" *ngIf="totalAttachedCount === 0">

        </span>
        <span class="text-muted fs11 ml-sm" *ngIf="totalAttachedCount > 0">
          {{ totalAttachedCount }} file{{ totalAttachedCount === 1 ? '' : 's' }} attached
        </span>

      </div>

    </div>

    <!-- Patient Chart panel -->
    <div class="updox-chart-panel" *ngIf="showChartPanel">
      <div class="updox-chart-panel-header">
        <span><i class="fa fa-folder-open-o mr-sm text-secondary"></i><strong>Select from Patient Chart</strong></span>
        <a class="text-muted" (click)="showChartPanel = false" title="Close"><i class="fa fa-times"></i></a>
      </div>

      <!-- Patient search -->
      <div class="updox-chart-patient-search" *ngIf="!chartPatient">
        <!-- wrap field + dropdown together so dropdown anchors to the input -->
        <div class="updox-patient-search-wrap">
          <div class="updox-patient-search-field">
            <i class="fa fa-search updox-patient-search-icon text-muted"></i>
            <input type="text" class="form-control input-sm updox-patient-search-input"
                   [(ngModel)]="chartPatientQuery"
                   (ngModelChange)="onChartPatientQueryChange($event)"
                   (blur)="closeChartPatientDropdownDelayed()"
                   placeholder="Search patient by name, phone or email…"
                   autocomplete="off" />
            <i class="fa fa-spinner fa-spin updox-patient-search-spinner text-muted"
               *ngIf="chartPatientSearchLoading"></i>
          </div>
          <div class="updox-patient-dropdown" *ngIf="showChartPatientDropdown">
            <div class="updox-patient-option" *ngFor="let p of chartPatientResults"
                 (mousedown)="selectChartPatient(p)">
              <span class="updox-avatar updox-avatar-xs">{{ patientInitialFor(p) }}</span>
              <div class="updox-patient-option-info">
                <div class="fw-500 fs13">{{ p.name }}</div>
                <div class="updox-patient-option-meta" *ngIf="patientDemographics(p) as demo">
                  <i class="fa fa-id-card-o mr-sm text-muted"></i>{{ demo }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="help-block fs11 m0 mt-xs" *ngIf="!chartPatientQuery">
          <i class="fa fa-info-circle mr-sm text-info"></i>Type at least 2 characters
        </p>
        <p class="help-block text-muted fs11 m0 mt-xs"
           *ngIf="chartPatientQuery && !chartPatientSearchLoading && chartPatientResults.length === 0 && !showChartPatientDropdown">
          <i class="fa fa-exclamation-circle mr-sm"></i>No patients found
        </p>
      </div>

      <!-- Selected patient header -->
      <div class="updox-chart-patient-bar" *ngIf="chartPatient">
        <span class="updox-avatar updox-avatar-xs">{{ patientInitialFor(chartPatient) }}</span>
        <div class="updox-chart-patient-info">
          <span class="fw-500 fs13">{{ chartPatient.name }}</span>
          <span class="text-muted fs11 ml-sm" *ngIf="patientDemographics(chartPatient) as demo">{{ demo }}</span>
        </div>
        <a class="btn btn-xs btn-default btn-outline" *ngIf="!draft.patientLocked" (click)="changeChartPatient()">
          <i class="fa fa-search mr-sm"></i>Change
        </a>
      </div>

      <!-- Document list -->
      <div class="updox-chart-docs" *ngIf="chartPatient">
        <div class="text-center text-muted p-sm" *ngIf="chartDocumentsLoading">
          <i class="fa fa-spinner fa-spin mr-sm"></i>Loading documents…
        </div>
        <div class="text-muted fs12 p-sm text-center" *ngIf="!chartDocumentsLoading && chartDocuments.length === 0">
          <i class="fa fa-inbox mr-sm"></i>No documents found for this patient
        </div>

        <ng-container *ngIf="!chartDocumentsLoading && chartDocuments.length > 0">
          <!-- Filter -->
          <div class="updox-chart-filter">
            <i class="fa fa-search text-muted mr-sm"></i>
            <input type="text" class="form-control input-sm updox-chart-filter-input"
                   [(ngModel)]="chartDocFilter"
                   placeholder="Filter documents…" />
          </div>

          <!-- Grouped document rows -->
          <div class="updox-chart-group" *ngFor="let group of groupedChartDocs; trackBy: trackByTypeName">
            <div class="updox-chart-group-label">{{ group.typeName }}</div>
            <div class="updox-chart-doc-row" *ngFor="let doc of group.docs; trackBy: trackByDocId"
                 (click)="toggleChartDoc(doc.id)"
                 [class.selected]="isDocSelected(doc.id)">
              <i class="fa fs14 mr-sm updox-chart-check-icon"
                 [class.fa-check-square]="isDocSelected(doc.id)"
                 [class.fa-square-o]="!isDocSelected(doc.id)"></i>
              <i class="fa {{ chartDocIcon(doc.content_type) }} mr-sm fs13"></i>
              <div class="updox-chart-doc-info">
                <span class="fw-500 fs13">{{ doc.name || doc.file_name }}</span>
                <span class="text-muted fs11 ml-sm" *ngIf="doc.date">· {{ doc.date | date:'MMM d, y' }}</span>
              </div>
              <span class="text-muted fs11" *ngIf="doc.file_size">{{ formatFileSize(doc.file_size) }}</span>
            </div>
          </div>

          <div class="text-muted fs12 p-sm text-center"
               *ngIf="filteredChartDocs.length === 0 && chartDocFilter">
            No documents match "{{ chartDocFilter }}"
          </div>
        </ng-container>

        <!-- Footer -->
        <div class="updox-chart-panel-footer" *ngIf="!chartDocumentsLoading && chartDocuments.length > 0">
          <span class="text-muted fs12" *ngIf="selectedChartDocCount === 0">Select documents to attach</span>
          <span class="text-info fs12 fw-500" *ngIf="selectedChartDocCount > 0">
            {{ selectedChartDocCount }} document{{ selectedChartDocCount === 1 ? '' : 's' }} selected
          </span>
          <div>
            <button type="button" class="btn btn-xs btn-default mr-sm"
                    (click)="showChartPanel = false">Cancel</button>
            <button type="button" class="btn btn-xs btn-info"
                    [disabled]="selectedChartDocCount === 0"
                    (click)="attachFromChart()">
              <i class="fa fa-paperclip mr-sm"></i>
              Attach{{ selectedChartDocCount > 0 ? ' ' + selectedChartDocCount : '' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer: Send / Save Draft / Discard -->
    <div class="updox-compose-footer">

      <button type="button" class="btn fs14 btn-secondary btn-sm mr-sm w-120"
              (click)="send()"
              [disabled]="!draft.to_address.trim() || isSending || isSavingDraft">
        <i class="fa fa-spinner fa-spin mr-sm" *ngIf="isSending"></i>
        <i class="fa fa-send mr-sm" *ngIf="!isSending"></i>
        {{ isSending ? 'Sending...' : 'Send' }}
      </button>
      <div class="updox-compose-attachments-header">
        <a tooltip="Attach from Your Device" class="btn w-sm fs12 pointer btn-sm btn-primary btn-outline mr-sm" (click)="triggerFileInput()">
          <i class="fa fa-upload mr-sm"></i>Your Device
        </a>
        <a tooltip="Attach from Patient Chart" class="btn fs12 pointer btn-sm btn-secondary btn-outline ml-sm"
           [class.active]="showChartPanel"
           (click)="toggleChartPanel()">
          <i class="fa fa-folder-open-o mr-sm"></i>Patient Chart
        </a>
      </div>


      <div><button tooltip="Save as Draft" type="button" class="btn fs12 pointer w-sm text-tertiary bg-transparent btn-sm mr-sm"
                   (click)="saveDraft()"
                   [disabled]="isSending || isSavingDraft"
                   title="Save as Draft">

        <i class="fa fa-spinner fa-spin" *ngIf="isSavingDraft"></i>
        Save as Draft
      </button>
        <a tooltip=" Discard Draft" class="fs12 pointer btn btn-danger btn-outline btn-sm " (click)="close.emit()">
          <i class="fa fa-trash-o"></i>
        </a></div>
    </div>
  </div>
</div>
